import { convertImage, toBase64 } from "@/utils/functions/Images-functions";
import Image from "next/image";
import { CSSProperties } from "react";

interface Props {
  src: string;
  alt: string;
  height?: number;
  width?: number;
  objectFit?: "contain" | "cover" | "fill";
  layout?: string; // "fixed" | "fill" | "intrinsic" | "responsive" | "raw";
  onClick?: () => void;
  className?: string;
  priority?: boolean;
  sizes?: string;
  style?: CSSProperties;
  quality?: number;
  noPlaceholder?: boolean;
  containerStyle?: CSSProperties;
  containerClassName?: string;
}
const sanitizeSrc = (srcLink: string) => {
  if (!srcLink) return "/";
  if (
    !(
      srcLink.startsWith("https://") ||
      srcLink.startsWith("http://") ||
      srcLink.startsWith("/")
    )
  ) {
    return "/" + srcLink;
  }
  return srcLink;
};

const NextImage: React.FC<Props> = ({
  src,
  alt,
  height,
  width,
  objectFit,
  layout,
  className = null,
  // priority = false,
  sizes,
  style,
  quality = 75,
  noPlaceholder = false,
  containerStyle,
  containerClassName,
  onClick,
}) => {
  const fill = !(!!width && !!height) && !style?.width;
  let props = {
    fill,
    width,
    height,
    style: {
      objectFit,
      objectPosition: "50% 50%",
      layout: (!!width && !!height) || style?.width ? layout : "fill",
      ...style,
    },
  };

  const isSmall = !!width && width < 50;
  return (
    <>
      {className ? (
        <Image
          placeholder={isSmall || noPlaceholder ? undefined : "blur"}
          blurDataURL={`data:image/svg+xml;base64,${toBase64(
            convertImage(10, 10),
          )}`}
          alt={alt}
          src={sanitizeSrc(src)}
          priority={false}
          onClick={onClick}
          {...props}
          className={className}
          sizes={sizes}
          quality={quality}
          loading="lazy"
        />
      ) : (
        <div
          className={"next-image-container " + containerClassName}
          style={{ ...containerStyle }}
        >
          <Image
            placeholder={isSmall || noPlaceholder ? undefined : "blur"}
            blurDataURL={`data:image/svg+xml;base64,${toBase64(
              convertImage(100, 100),
            )}`}
            alt={alt}
            onClick={onClick}
            {...props}
            src={sanitizeSrc(src)}
            sizes={sizes}
            quality={quality}
            priority={false}
            loading="lazy"
          />
        </div>
      )}
    </>
  );
};

export default NextImage;
